import Vue from 'vue'
import Router from 'vue-router'

//车辆 管理///////////////////////////////
const outclassdriver = () => import("@/components/cw/out_class_driver"); //
const outclassuser = () => import("@/components/cw/out_class_user"); //
const outclassyf = () => import("@/components/cw/out_class_yf"); //
const outclassother = () => import("@/components/cw/out_class_other"); //
const outclassdtys = () => import("@/components/cw/out_class_dtys"); //短途运输
const outclassback = () => import("@/components/cw/out_class_back"); //退费扣款

const cwbefore = () => import("@/components/cw/cwbefore");			//部门经理审核
const cwcheck = () => import("@/components/cw/cwcheck");			//费用核对
const cwpass = () => import("@/components/cw/cwpass");		//费用审核
const cwpay = () => import("@/components/cw/cwpay");		//费用打款
const cwpaylate = () => import("@/components/cw/cwpaylate");		//费用打款延迟

const userbx = () => import("@/components/cw/userbx");		//个人报销
const userjk = () => import("@/components/cw/userjk");		//个人借款
const userxz = () => import("@/components/cw/userxz");		//个人销账
const ptbz = () => import("@/components/cw/ptbz");		//普通报账

const tabiodetail_ys = () => import("@/components/cw/tab_io_detail_ys");		//运输费用合计
const tabiodetail_ys_d = () => import("@/components/cw/tab_io_detail_ys_d");		//运输费用明细
const tabiodetail_gr = () => import("@/components/cw/tab_io_detail_gr");		//个人费用流水
const tabpaylist = () => import("@/components/cw/tab_user_gua");		//账号挂帐

const cwpassok = () => import("@/components/cw/tab_cw_pass_ok");		//财务审核明细

const transendpass = () => import("@/components/cw/a_bigorder");		//出车审核-运输大订单核算
const transendpass_ph = () => import("@/components/cw/a_bigorder_ph");		//出车审核-配货订单核算


const cardclass = () => import("@/components/cw/card_class");		//卡类型
const cardinfo = () => import("@/components/cw/card_info");			//卡信息
const cardiodetail = () => import("@/components/cw/card_io_detail");	//卡流水
const cartocards = () => import("@/components/cw/card_and_car");		//卡与车牌
const trans_auto_end = () => import("@/components/cw/tab_trans_cards_check");	//卡流水结算合计




Vue.use(Router)

export default[
	{
		name: "outclassyf",
		path: "/outclassyf",
		component: outclassyf,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "运输费用申请分类"
		}
	},
	{
		name: "outclassuser",
		path: "/outclassuser",
		component: outclassuser,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "个人费用报销分类"
		}
	},
	{
		name: "outclassdriver",
		path: "/outclassdriver",
		component: outclassdriver,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "运输费用报销分类"
		}
	},
	{
		name: "outclassother",
		path: "/outclassother",
		component: outclassother,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "其他费用分类"
		}
	},
	{
		name: "outclassdtys",
		path: "/outclassdtys",
		component: outclassdtys,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "短途运输费用分类"
		}
	},
	{
		name: "outclassback",
		path: "/outclassback",
		component: outclassback,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "运输退费与扣款"
		}
	},
	{
		name: "cwbefore",
		path: "/cwbefore",
		component: cwbefore,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "部门经理审核"
		}
	},
	{
		name: "cwcheck",
		path: "/cwcheck",
		component: cwcheck,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "费用核对"
		}
	},
	{
		name: "cwpass",
		path: "/cwpass",
		component: cwpass,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "费用审核"
		}
	},
	{
		name: "cwpay",
		path: "/cwpay",
		component: cwpay,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "财务打款"
		}
	},
	{
		name: "cwpaylate",
		path: "/cwpaylate",
		component: cwpaylate,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "财务延迟付款"
		}
	},
	{
		name: "userbx",
		path: "/userbx",
		component: userbx,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "个人报销"
		}
	},
	{
		name: "userjk",
		path: "/userjk",
		component: userjk,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "个人借款"
		}
	},
	{
		name: "userxz",
		path: "/userxz",
		component: userxz,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "个人销账"
		}
	},
	{
		name: "ptbz",
		path: "/ptbz",
		component: ptbz,
		meta: {
			requiresAuth: true,
			keepAlive: false, // 不需要被缓存
			title: "普通报账"
		}
	},
	{
	  name: "io_detail_ys",
	  path: "/io_detail_ys",
	  component: tabiodetail_ys,
	  meta: {
	    requiresAuth: true,
	    keepAlive: true, // 不需要被缓存
	    title: "运输费用合计"
	  }
	},
	{
	  name: "io_detail_d_ys",
	  path: "/io_detail_d_ys",
	  component: tabiodetail_ys_d,
	  meta: {
	    requiresAuth: true,
	    keepAlive: true, // 不需要被缓存
	    title: "运输费用明细"
	  }
	},
	{
	  name: "io_detail_gr",
	  path: "/io_detail_gr",
	  component: tabiodetail_gr,
	  meta: {
	    requiresAuth: true,
	    keepAlive: true, // 不需要被缓存
	    title: "个人费用审核流水"
	  }
	},
	{
	  name: "user_pay_list",
	  path: "/user_pay_list",
	  component: tabpaylist,
	  meta: {
	    requiresAuth: true,
	    keepAlive: true, // 不需要被缓存
	    title: "费用收支流水"
	  }
	},
	{
	  name: "cw_pass_ok",
	  path: "/cw_pass_ok",
	  component: cwpassok,
	  meta: {
	    requiresAuth: true,
	    keepAlive: true, // 不需要被缓存
	    title: "财务审核明细"
	  }
	},
	{
	  name: "order_all",
	  path: "/order_all",
	  component: transendpass,
	  meta: {
	    requiresAuth: true,
	    keepAlive: true, // 不需要被缓存
	    title: "发货订单核算"
	  }
	},
	{
	  name: "order_all_ph",
	  path: "/order_all_ph",
	  component: transendpass_ph,
	  meta: {
	    requiresAuth: true,
	    keepAlive: true, // 不需要被缓存
	    title: "配货订单核算"
	  }
	},
	{
	  name: "cardclass",
	  path: "/cardclass",
	  component: cardclass,
	  meta: {
	    requiresAuth: true,
	    keepAlive: true, // 不需要被缓存
	    title: "卡类型"
	  }
	},
	{
	  name: "cardinfo",
	  path: "/cardinfo",
	  component: cardinfo,
	  meta: {
	    requiresAuth: true,
	    keepAlive: true, // 不需要被缓存
	    title: "卡信息"
	  }
	},
	{
	  name: "cardiodetail",
	  path: "/cardiodetail",
	  component: cardiodetail,
	  meta: {
	    requiresAuth: true,
	    keepAlive: true, // 不需要被缓存
	    title: "卡流水"
	  }
	},
	{
	  name: "cartocards",
	  path: "/cartocards",
	  component: cartocards,
	  meta: {
	    requiresAuth: true,
	    keepAlive: true, // 不需要被缓存
	    title: "卡与车牌绑定"
	  }
	},
	{
	  name: "trans_auto_end",
	  path: "/trans_auto_end",
	  component: trans_auto_end,
	  meta: {
	    requiresAuth: true,
	    keepAlive: true, // 不需要被缓存
	    title: "卡流水"
	  }
	}
	
]